export default __webpack_public_path__ + "static/media/help_screen_fg.3d82f277.png";